import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useParams } from "react-router";
import Navigation from "../../components/Navigation/Navigation";
import { request } from "../../utils/axios-utils";
import "./menuOrder.css";
import dragIcon from "../../assets/drag.png";
import arrowIcon from "../../assets/right_arrow.png";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Link } from "react-router-dom";

const MenuOrder = () => {
  const { slug } = useParams();

  const [mainCategories, setMainCategories] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const [loading, setLoading] = useState("");

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading("data");

        const categoriesResponse = await request({
          url: "/member/get-main-categories",
          method: "POST",
          data: { slug },
        });
        setMainCategories(categoriesResponse.data.mainCategories || []);

        const response = await request({
          url: "/member/get-languages",
          method: "POST",
          data: { slug },
        });

        setLanguageList(response.data.languages);
      } catch (error) {
        toast.error(error.response.data.message);
      } finally {
        setLoading("");
      }
    };

    getData();
  }, []);

  const onCategoryDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }

    const { source, destination } = result;

    if (source.index === destination.index) {
      return;
    }

    const updatedCategories = Array.from(mainCategories);
    const [movedCategory] = updatedCategories.splice(source.index, 1);
    updatedCategories.splice(destination.index, 0, movedCategory);

    setMainCategories(updatedCategories);

    try {
      const response = await request({
        url: "/member/update-category-order",
        method: "POST",
        data: { updatedCategories, slug },
      });

      toast.success(response.data.message);
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  return (
    <Navigation isLoading={loading === "data"}>
      <h1 className="page-content-h">Menu Order</h1>
      <p className="page-content-p">Manage your items and categories order.</p>

      <DragDropContext onDragEnd={onCategoryDragEnd}>
        <Droppable droppableId="categories" direction="vertical">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className="languages-container"
            >
              {mainCategories.map((category, index) => (
                <Draggable
                  key={category.id}
                  draggableId={category.id}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <Link
                      to={`/${slug}/menu-order/${category.id}`}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className={`menu-order-div ${
                        snapshot.isDragging ? "dragging" : ""
                      }`}
                    >
                      <div className="menu-order-name-div">
                        <img className="menu-order-drag-img" src={dragIcon} />
                        <p className="menu-order-name">
                          {category.name[languageList[0]]}
                        </p>
                      </div>
                      <img className="menu-order-arrow-img" src={arrowIcon} />
                    </Link>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Navigation>
  );
};

export default MenuOrder;
